import React from 'react';
import { StyleSheet, View } from 'react-native';

import IconButton from '@components/IconButton';
import Image from '@components/Image';
import Surface from '@components/Surface';

const CLOSE_BUTTON_SIZE = 24;
const CLOSE_ICON_SIZE = 18;

export type SelectedImagePreviewProps = {
  /** Image source rendered as the selected image. */
  source: NonNullable<React.ComponentProps<typeof Image>['source']>;
  /** Called when the selected image is removed. */
  onRemove: () => void;
  /** Renders the selected image as a circle based on its resolved size. */
  circle?: boolean;
  /** Style applied to the selected image. */
  imageStyle?: React.ComponentProps<typeof Image>['style'];
  /** Style applied to the wrapper around the image and remove button. */
  containerStyle?: React.ComponentProps<typeof View>['style'];
};

export function SelectedImagePreview({
  source,
  onRemove,
  circle,
  imageStyle,
  containerStyle,
}: SelectedImagePreviewProps) {
  return (
    <View style={containerStyle}>
      <Surface style={styles.closeButtonSurface}>
        <IconButton
          icon="close-circle"
          accessibilityLabel="Remove photo"
          size={CLOSE_ICON_SIZE}
          style={styles.closeButton}
          onPress={onRemove}
        />
      </Surface>
      <Image source={source} circle={circle} style={imageStyle} />
    </View>
  );
}

const styles = StyleSheet.create({
  closeButton: {
    height: CLOSE_BUTTON_SIZE,
    margin: 0,
    width: CLOSE_BUTTON_SIZE,
  },
  closeButtonSurface: {
    borderRadius: CLOSE_BUTTON_SIZE / 2,
    height: CLOSE_BUTTON_SIZE,
    position: 'absolute',
    right: -6,
    top: -6,
    width: CLOSE_BUTTON_SIZE,
    zIndex: 1,
  },
});
